<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog" :close-on-click-modal="false">
        <el-form ref="formValidate" :model="model" :rules="rules" label-width="120px">
            <el-form-item label="标题：" prop="title">
                <el-input v-model="model.title"></el-input>
            </el-form-item>
            <el-form-item label="报告日期：" prop="report_date">
                <el-date-picker v-model="model.report_date" type="date" value-format="yyyy-MM-dd" placeholder="选择日期"></el-date-picker>
            </el-form-item>
            <el-form-item label="报告内容：" prop="content">
                <vue-ueditor-wrap v-model="content1" :config="myConfig" editor-id="day_edit_container" @ready="UEditorReady"></vue-ueditor-wrap>
            </el-form-item>
            <el-form-item label="选择审核人：" prop="zd_sh_id">
                <el-select v-model="model.zd_sh_id" filterable placeholder="请选择" clearable>
                    <el-option
                        v-for="item in shUserList"
                        :key="item.id"
                        :label="item.realname"
                        :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="closeDialog" size="medium">取 消</el-button>
            <el-button type="primary" @click="handleSubmit(0)" size="medium">确 定</el-button>
            <el-button type="success" @click="handleSubmit(1)" size="medium">提 交</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { saveModel, getModelById } from '@/api/common'
import { getShUserList } from '@/api/user'
import VueUeditorWrap from 'vue-ueditor-wrap';

export default {
    name: 'dayReportEdit',
    mixins: [editutil],
    components: {VueUeditorWrap},
    data() {
        return {
            model: {
                title: '',
                report_date: '',
                content: '',
                creator_id: '',
                creator_name: '',
                create_time: '',
                state: '0',
                zd_sh_id: '',
            },
            getObj:{
                url:'/api/admin/dayreport/info',
                data:{
                    key:'id',
                    value:''
                }
            },
            enu_name: [],
            rules: {
                title: [
                    {required: true, message: '标题不能为空', trigger: 'blur'}
                ],
                report_date: [
                    {required: true, message: '报告日期不能为空', trigger: 'blur'}
                ],
                content: [
                    {required: true, message: '报告内容不能为空', trigger: 'blur'}
                ],
            },
            myConfig: {
                //你的UEditor资源存放的路径,相对于打包后的index.html
                UEDITOR_HOME_URL: '/ueditor/',
                //编辑器不自动被内容撑高
                autoHeightEnabled: false,
                autoFloatEnabled: false,
                //初始容器宽度
                initialFrameWidth: '100%',
                //初始容器高度
                initialFrameHeight: 280,
            },
            content1: '',
            editor: null,
            shUserList: [],
        };
    },
    methods: {
        UEditorReady() {
            this.editor = UE.getEditor('day_edit_container');
        },
        getModelData() {
            this.model = this.copyObj(this.init_model);
            if (this.id > 0) {
                this.getObj.data.value = this.id;
                getModelById(this.getObj).then(res => {
                    if (res.code === 1) {
                        this.model = res.data;
                        this.content1 = this.model.content+""
                        this.formateData();
                    } else {
                        this.$msg(res.msg)
                        this.closeDialog()
                    }
                })
            }
        },
        //保存方法
        handleSubmit(state) {
            this.model.content = this.content1
            this.$refs[this.form_name].validate((valid) => {
                if (valid) {
                    this.formatModel();
                    let config = {
                        url:'/api/admin/dayreport/save'
                    }
                    this.model.state = state
                    config["data"] = this.model;
                    saveModel(config).then(res=>{
                        if(res.code===1){
                            this.$msgs("保存成功！");
                            this.$emit("on-save-ok",{});
                        }else{
                            this.$msg(res.msg)
                        }
                    }).catch();
                }
            })
        },
        loadOtherData() {
            //加载其他内容， 可重写
            this.getShUserList()
        },
        getShUserList(){
            getShUserList().then(res=>{
                if(res.code == 1){
                    this.shUserList = res.data
                }
            })
        },
    }
};
</script>